import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledPotentialMatrix = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
  position: relative;

  & .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    height: 72px;
    border-top: 1px solid ${theme.colors.purple_2};
    padding: 0 20px;
  }
`;

export const StyledMatrixFilters = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  column-gap: 16px;
  padding: 8px 24px;
  border-bottom: 1px solid ${theme.colors.purple_2};

  & .select-practice-container {
    max-width: 300px;
  }

  & .switch-container {
    justify-self: center;
  }

  & .filters-end-container {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-self: flex-end;

    & .select-year-container {
      width: 100px;
    }

    & .search-container {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      height: 48px;
    }
  }
`;

export const StyledInlineSearchPanel = styled.div<{ $visible: boolean }>`
  position: absolute;
  right: 0;
  top: 0;
  background-color: ${theme.colors.white};
  max-width: ${({ $visible }) => ($visible ? "300px" : "0")};
  transform: ${({ $visible }) => ($visible ? "scaleX(1)" : "scaleX(0)")};
  transform-origin: right center;
  transition:
    max-width 0.3s ease-in-out,
    transform 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  display: flex;
  align-items: center;
  z-index: 2;

  & > div {
    width: 270px;
    visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};

    @media (max-width: ${({ theme }) => theme.breakpoints.XL}px) {
      width: 220px;
    }
  }
`;

export const StyledMessageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 24px;
`;
